import { lazy } from "react";

const LazyRulePage = lazy(() =>
    import("./RulePage").then(module => ({ default: module.RulePage }))
);

export { LazyRulePage };
